import {
  FluentIcon,
  iconFilledClassName,
  iconRegularClassName,
  AppsAddInFilled,
  AppsAddInRegular,
  ArrowLeftRegular,
  ArrowSwapFilled,
  ArrowSwapRegular,
  ArrowSyncRegular,
  BuildingFilled,
  BuildingMultipleFilled,
  BuildingMultipleRegular,
  BuildingRegular,
  bundleIcon,
  CheckmarkRegular,
  DismissRegular,
  GlobeRegular,
  HomeFilled,
  HomeRegular,
  InfoRegular,
  PaymentFilled,
  PaymentRegular,
  PeopleFilled,
  PeopleRegular,
  PersonArrowRightRegular,
  PersonSwapRegular,
  PlugConnectedRegular,
  ServerFilled,
  ServerRegular,
  SettingsFilled,
  SettingsRegular,
  SignOutRegular,
  TagMultipleFilled,
  TagMultipleRegular,
  ArchiveFilled,
  ArchiveRegular,
  WeatherMoonRegular,
  WeatherSunnyRegular,
  CircleSmallFilled,
  ArrowDownloadRegular,
  BotRegular,
  CalculatorRegular,
  DataPieFilled,
  DataPieRegular,
  ChatAddRegular,
  ChatFilled,
  ChatRegular,
  DocumentFilled,
  DocumentRegular,
  DocumentTableFilled,
  DocumentTableRegular,
  ErrorCircleRegular,
  HistoryFilled,
  HistoryRegular,
  PersonRegular,
  SendRegular,
  StopRegular,
  EditRegular,
  AddRegular,
  DeleteRegular,
  ArrowUndoRegular,
  SearchRegular,
  KeyMultipleFilled,
  KeyMultipleRegular,
  FolderFilled,
  FolderRegular,
  OpenRegular,
  CopyRegular,
  CloudArrowUpRegular,
  MailRegular,
  BeakerRegular,
  PlugDisconnectedRegular,
  ChevronRightRegular,
  LibraryFilled,
  LibraryRegular,
  BookOpenFilled,
  BookOpenRegular,
  CheckmarkCircleRegular,
  DismissCircleRegular,
  RocketRegular,
  BoxRegular,
  BoxArrowLeftRegular,
  PauseCircleRegular,
  PlayCircleRegular,
  PlayRegular,
  ArrowExportRegular,
  SparkleRegular,
  BranchCompareRegular,
  PuzzlePieceFilled,
  PuzzlePieceRegular,
  RadarRegular,
  KeyRegular,
  ShieldTaskFilled,
  ShieldTaskRegular,
  PeopleTeamFilled,
  PeopleTeamRegular,
  ClipboardTaskListLtrFilled,
  ClipboardTaskListLtrRegular,
  DocumentSearchFilled,
  DocumentSearchRegular,
  DatabaseSearchRegular,
  BrainCircuitRegular,
  DatabaseArrowRightRegular,
  PersonLockRegular,
  DocumentArrowRightRegular,
  WarningRegular,
  DeveloperBoardFilled,
  DeveloperBoardRegular,
  CalendarClockFilled,
  CalendarClockRegular,
  StoreMicrosoftFilled,
  StoreMicrosoftRegular,
  BoxArrowUpFilled,
  BoxArrowUpRegular,
  BookDatabaseFilled,
  BookDatabaseRegular,
  CoinMultipleFilled,
  CoinMultipleRegular,
} from '@fluentui/react-icons';

//
// The icon set of the app. Icons are referred to by name (the nav model's iconName is such a name), so
// nothing outside baseComponents imports @fluentui/react-icons. A bundled icon shows its filled variant
// on hover and when selected, the Fluent v9 convention.
//
const iconMap = {
  Home: bundleIcon(HomeFilled, HomeRegular),
  Settings: bundleIcon(SettingsFilled, SettingsRegular),
  //its own glyph: the plug is Connect's (one glyph, one meaning)
  Integrations: bundleIcon(AppsAddInFilled, AppsAddInRegular),
  Backup: bundleIcon(ArchiveFilled, ArchiveRegular),
  Users: bundleIcon(PeopleFilled, PeopleRegular),
  Subscription: bundleIcon(PaymentFilled, PaymentRegular),
  TenantAdmin: bundleIcon(ServerFilled, ServerRegular),
  Tenants: bundleIcon(BuildingMultipleFilled, BuildingMultipleRegular),
  SubscriptionTypes: bundleIcon(TagMultipleFilled, TagMultipleRegular),
  Marketplace: bundleIcon(StoreMicrosoftFilled, StoreMicrosoftRegular),
  Publishing: bundleIcon(BoxArrowUpFilled, BoxArrowUpRegular),
  CapabilityCatalog: bundleIcon(BookDatabaseFilled, BookDatabaseRegular),
  AICredits: bundleIcon(CoinMultipleFilled, CoinMultipleRegular),
  AgentToAgent: bundleIcon(ArrowSwapFilled, ArrowSwapRegular),
  Organization: bundleIcon(BuildingFilled, BuildingRegular),
  Dot: CircleSmallFilled,
  Back: ArrowLeftRegular,
  Refresh: ArrowSyncRegular,
  Checkmark: CheckmarkRegular,
  Dismiss: DismissRegular,
  Globe: GlobeRegular,
  Info: InfoRegular,
  SwitchAccount: PersonSwapRegular,
  SignOut: SignOutRegular,
  DarkMode: WeatherMoonRegular,
  LightMode: WeatherSunnyRegular,
  Chat: bundleIcon(ChatFilled, ChatRegular),
  NewChat: ChatAddRegular,
  History: bundleIcon(HistoryFilled, HistoryRegular),
  Document: bundleIcon(DocumentFilled, DocumentRegular),
  Spreadsheet: bundleIcon(DocumentTableFilled, DocumentTableRegular),
  Chart: bundleIcon(DataPieFilled, DataPieRegular),
  Download: ArrowDownloadRegular,
  Send: SendRegular,
  Stop: StopRegular,
  Error: ErrorCircleRegular,
  Assistant: BotRegular,
  Person: PersonRegular,
  TransferOwner: PersonArrowRightRegular,
  Edit: EditRegular,
  Add: AddRegular,
  Delete: DeleteRegular,
  Restore: ArrowUndoRegular,
  Search: SearchRegular,
  IdentityIssuers: bundleIcon(KeyMultipleFilled, KeyMultipleRegular),
  Folder: bundleIcon(FolderFilled, FolderRegular),
  OpenExternal: OpenRegular,
  Copy: CopyRegular,
  SaveTo: CloudArrowUpRegular,
  Mail: MailRegular,
  Test: BeakerRegular,
  Connect: PlugConnectedRegular,
  Disconnect: PlugDisconnectedRegular,
  ChevronRight: ChevronRightRegular,
  Skills: bundleIcon(LibraryFilled, LibraryRegular),
  Approve: CheckmarkCircleRegular,
  Reject: DismissCircleRegular,
  Publish: RocketRegular,
  //the box pair of a Skill's owner lane; the archive box itself is Backup's glyph
  Archive: BoxRegular,
  Unarchive: BoxArrowLeftRegular,
  Suspend: PauseCircleRegular,
  Reactivate: PlayCircleRegular,
  Export: ArrowExportRegular,
  Sparkle: SparkleRegular,
  Compare: BranchCompareRegular,
  Capabilities: bundleIcon(PuzzlePieceFilled, PuzzlePieceRegular),
  DocumentLibrary: bundleIcon(BookOpenFilled, BookOpenRegular),
  Discover: RadarRegular,
  Key: KeyRegular,
  Policies: bundleIcon(ShieldTaskFilled, ShieldTaskRegular),
  Groups: bundleIcon(PeopleTeamFilled, PeopleTeamRegular),
  Approvals: bundleIcon(ClipboardTaskListLtrFilled, ClipboardTaskListLtrRegular),
  Audit: bundleIcon(DocumentSearchFilled, DocumentSearchRegular),
  DataRetrieval: DatabaseSearchRegular,
  Reasoning: BrainCircuitRegular,
  ExternalAction: DatabaseArrowRightRegular,
  IdentityBoundary: PersonLockRegular,
  Output: DocumentArrowRightRegular,
  Calculation: CalculatorRegular,
  Warning: WarningRegular,
  Models: bundleIcon(DeveloperBoardFilled, DeveloperBoardRegular),
  Run: PlayRegular,
  Schedule: bundleIcon(CalendarClockFilled, CalendarClockRegular),
} satisfies Record<string, FluentIcon>;

export type IPIconName = keyof typeof iconMap;

export const isIPIconName = (name: string | undefined): name is IPIconName => name !== undefined && name in iconMap;

export interface IPIconProps {
  name: IPIconName;
  className?: string;
  fontSize?: number;
  //shows the filled variant of a bundled icon, as for a selected entry
  filled?: boolean;
}

export const IPIcon = (props: IPIconProps) => {
  const Icon = iconMap[props.name];

  return <Icon className={props.className} fontSize={props.fontSize} filled={props.filled} />;
};

//the component of a named icon, for slots that take an icon component instead of an element
export const getIPIconComponent = (name: IPIconName): FluentIcon => iconMap[name];

export { iconFilledClassName as ipIconFilledClassName, iconRegularClassName as ipIconRegularClassName };
